export default {
  init() {
    // JavaScript to be fired on all pages

$(document).ready(function() { // Choosing AGS dropdown menu
document.getElementsByTagName('body')[0].style.visibility = 'visible';
$('.ags_relocation .ags-form').find('.container').removeClass();
$('.wpcf7-form fieldset input').blur(function(){
var className = $(this).attr('class');
if ( className.indexOf('first-name') > -1 ) {
  $('#tabs-1 form').find('#first_name').val($('.first-name').val());
}
if ( className.indexOf('last-name') > -1 ) {
  $('#tabs-1 form').find('#last_name').val($('.last-name').val());
}
if ( className.indexOf('email') > -1 ) {
  $('#tabs-1 form').find('#email_address').val($('input.email').val());
}
if ( className.indexOf('telephone') > -1 ) {
  $('#tabs-1 form').find('#tel_contact').val($('.telephone').val());
}
});

$('.ags_relocation #form input').blur(function(){
var idName = $(this).attr('id')
if ( idName.indexOf('first_name') > -1 ) {
  $('.wpcf7-form').find('.first-name').val($('#first_name').val());
}
if ( idName.indexOf('last_name') > -1 ) {
  $('.wpcf7-form').find('.last-name').val($('#last_name').val());
}
if ( idName.indexOf('email_address') > -1 ) {
  $('.wpcf7-form').find('.email').val($('#email_address').val());
}
if ( idName.indexOf('tel_contact') > -1 ) {
  $('.wpcf7-form').find('.telephone').val($('#tel_contact').val());
}
});

$('.ags_relocation.page-id-35 .subject select option:nth-child(1)').val('');

$('fieldset .subject select').change(function(){
  if ( $(this).val() == 'Removal Quote' )
  {
    
    $('.wpcf7-form').fadeOut(200, function(){
      $('#tabs-1, .return-form').fadeIn(200);
    });
    $('#intro h1').text("Get a free moving quote");
    $('#intro h5 span:nth-child(2)').show();
    //$('#intro h5 span:nth-child(2) span').show();
    $('#intro h5 span:nth-child(2)').prev().hide();
  }
});

$('.ags_relocation .return-form a').click(function(){
  $('#tabs-1, .return-form').fadeOut(200, function(){
      $('.wpcf7-form').fadeIn(200);
      $('.subject select').val('');
      $('.ags_relocation #intro h1').text('Contact Us');
      $('#intro h5 span:nth-child(2)').hide();
      //$('#intro h5 span:nth-child(2) span').hide();
      $('#intro h5 span:nth-child(2)').prev().show();
    }); 
});

$('.ags_relocation .wpcf7-form').prepend('<p class="error-response-msg">Please correct the below fields highlighted in red.</p>');

$('.ags_relocation #tabs-1').find('.error-msg').each(function(){
  if ( $.trim($(this).text()) != '' )
  {
    $('#tabs-1').show();
    $('.wpcf7-form').hide();
  }
});

$('#sidebar .widget, .footer-post-col').find('ul li').each(function(){
var pwd = $(this)[0].innerText;
if ( pwd.indexOf('Protected:') >= 0 )
$(this).addClass('hide')
})

if ( $(window).width() > 900 ) {
$("li#menu-item-45 a:nth-child(1)").attr("href", "#"); // relo
$('.nav > li:nth-child(2)').click(function(){ 
$('#choose-dropdown').toggleClass('display-block');
});
$('.nav > li:not(:nth-child(2))').click(function(){
$('#choose-dropdown').delay(500).removeClass('display-block');
});
//$('.wpml-ls-item-pt-pt').hide();
//$('.wpml-ls-item-de').hide();
}
});
$(document).ready(function() { // Services dropdown menu
  if ( $(window).width() > 900 ) {
$("li#menu-item-23847 a:nth-child(1)").attr("href", "#"); // relo
$('.nav > li:nth-child(3)').click(function(){
$('#services-dropdown').toggleClass('display-block');
}); 
$('.nav > li:not(:nth-child(3))').click(function(){
$('#services-dropdown').delay(500).removeClass('display-block');
});
}
});
$(document).ready(function() { // Network dropdown menu
if ( $(window).width() > 900 ) {
$("li#menu-item-39 a:nth-child(1)").attr("href", "#"); // relo
$('.nav > li:nth-child(4)').click(function(){
$('#branch_dropdown_menu').toggleClass('display-block');
});
$('#mega-menu-primary_navigation > li:nth-child(4)').click(function(){
$('#branch_dropdown_menu').toggleClass('display-block');
});
$('.nav > li:not(:nth-child(4))').click(function(){
$('#branch_dropdown_menu').delay(500).removeClass('display-block');
});
$('#mega-menu-primary_navigation > li:not(:nth-child(4))').click(function(){
$('#branch_dropdown_menu').delay(500).removeClass('display-block');
});
// WORKS FOR ALL DROPDOWNS!
$('#topbar .container').hover(function(){
$('.dropdown-base').delay(500).removeClass('display-block');
});
$('.custom-logo').hover(function(){
$('.dropdown-base').delay(500).removeClass('display-block');
});
$('.ags_container').hover(function(){
$('.dropdown-base').delay(500).removeClass('display-block');
});
$('.nav > li:nth-child(6)').hover(function(){
$('.dropdown-base').delay(500).removeClass('display-block');
});
$('#mega-menu-primary_navigation > li:nth-child(6)').hover(function(){
$('.dropdown-base').delay(500).removeClass('display-block');
});
$('button.cross').click(function(){
$('.dropdown-base').delay(500).removeClass('display-block');
});
}
});
$(document).ready(function(){ 
if ( $(window).width() > 900 ) { // Regular submenu (hover)
$('body.pt-pt #menu-item-26092').addClass('menu-animation');
$('.nav > li.menu-animation >  a:nth-of-type(1)').hover(function(){
  $('.menu-animation ul.sub-menu').css({'opacity': '1'});
});
$('#topbar .container').hover(function(){
  $('.menu-animation ul.sub-menu').delay(500).css({'opacity': '0'});
});
$('.custom-logo').hover(function(){
  $('.menu-animation ul.sub-menu').delay(500).css({'opacity': '0'});
});
$('.ags_container').hover(function(){
  $('.menu-animation ul.sub-menu').delay(500).css({'opacity': '0'});
});
$('.nav > li:not(.menu-animation)').hover(function(){
  $('.menu-animation ul.sub-menu').css({'opacity': '0'});
});
}
// end
if ( $('.country-content').is(':visible') ){
$('.content-dynamic').remove()
}
    // Query desktop screens
if ( $(window).width() > 900 ) {
// Froesch Receipt
var url = window.location.href;
var brand_name = url.split('=');
if ( brand_name[1] == 'froesch' ){
$('input[name="brand-name"]').val('AGS FROESCH');
}
if ( $('.single-branch').length == 1 ){ // fire only on branch pages
$('.accr_logos img').each(function(){
if ( $(this).attr('title') == 'iso_logo.gig' ){
$(this).replaceWith('<a href="http://www.sgs.com/certifiedclients" target="_blank"><img src="https://tray-international.intragest.info/images/accreditation/iso_logo.gif" align="center" title="iso_logo.gig"></a>');
}
})
}

// quote/contact menu buttons
$('.de.ags_records ul.nav > li:nth-child(6)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-post_type menu-item-object-page menu-item-75" id="mega-menu-item-75"><div><a class="menu-quote-button-link" href="/kontaktseite" tabindex="0"><i class="fa fa-edit"></i>Kontaktseite</a></div></li>');
$('.en.ags_movers ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="https://www.agsmovers.com/moving-quote" tabindex="0"><i class="fa fa-edit"></i>Get a quote</a></div></li>');
$('.fr.ags_movers ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="https://www.ags-demenagement.com/devis-demenagement" tabindex="0"><i class="fa fa-edit"></i>DEMANDE DE DEVIS</a></div></li>');
$('li#menu-item-75').replaceWith('<li class="menu-btn-red menu-item menu-item-type-post_type menu-item-object-page menu-item-75" id="mega-menu-item-75"><div><a class="menu-quote-button-link" href="/contact-us" tabindex="0"><i class="fa fa-edit"></i>CONTACT</a></div></li>');
$('li#menu-item-23705').replaceWith('<li class="menu-btn-red menu-item menu-item-type-post_type menu-item-object-page menu-item-23705"><div><a class="menu-quote-button-link" href="/nous-contacter" tabindex="0"><i class="fa fa-edit"></i>NOUS CONTACTER</a></div></li>');
$('li#menu-item-37').replaceWith('<li class="menu-btn-red menu-item menu-item-type-post_type menu-item-object-page menu-item-37" id="mega-menu-item-37"><div><a class="menu-quote-button-link" href="/contact-us" tabindex="0"><i class="fa fa-edit"></i>CONTACT</a></div></li>');
$('li#menu-item-26109').replaceWith('<li class="menu-btn-red menu-item menu-item-type-post_type menu-item-object-page menu-item-26109" id="mega-menu-item-26109"><div><a class="menu-quote-button-link" href="/contact-us" tabindex="0"><i class="fa fa-edit"></i>CONTACT</a></div></li>');

$('.menu-item-41372, .menu-item-41373, .menu-item-41374, .menu-item-41375').addClass('display-none');

// different button for every language
$('.ags_movers.de ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/angebot-anfordern/" tabindex="0"><i class="fa fa-edit"></i> Kostenloses Angebot</a></div></li>');
$('.ags_movers.zh-hans ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/%E5%BC%95%E7%94%A8%E5%8F%A5/" tabindex="0"><i class="fa fa-edit"></i> 报价</a></div></li>');
$('.ags_movers.cs ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/pozadat-o-cenovou-nabidku/" tabindex="0"><i class="fa fa-edit"></i> Získejte cenovou nabídku</a></div></li>');
$('.ags_movers.pl ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> Uzyskaj wycenę</a></div></li>');
$('.ags_movers.bg ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> получете безплатна оферта</a></div></li>');
$('.ags_movers.hr ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> Potražite ponudu</a></div></li>');
$('.ags_movers.ru ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> Предложение</a></div></li>');
$('.ags_movers.ko ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> 무료견적</a></div></li>');
$('.ags_movers.hu ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> Ajánlat</a></div></li>');
$('.ags_movers.es ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/solicite-un-presupuesto/" tabindex="0"><i class="fa fa-edit"></i> Obtener presupuesto</a></div></li>');
$('.ags_movers.sl ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> Obrazec za povpraševanje</a></div></li>');
$('.ags_movers.ro ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> Solicita o oferta</a></div></li>');
$('.ags_movers.pt-pt ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/solicite-um-orcamento/" tabindex="0"><i class="fa fa-edit"></i> Obter um orçamento</a></div></li>');
$('.ags_movers.he ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="/moving-quote/" tabindex="0"><i class="fa fa-edit"></i> קבל הצעת מחיר</a></div></li>');
$('.ags_movers.nl ul.nav > li:nth-child(7)').replaceWith('<li class="menu-btn-red menu-item menu-item-type-custom menu-item-object-custom menu-item-15981" id="menu-item-15981"><div><a class="menu-quote-button-link" href="https://www.agsmovers.nl/een-offerte-aanvragen/" tabindex="0"><i class="fa fa-edit"></i> Offerte aanvragen</a></div></li>');

if ($(".quality-accreditations").is(":visible") || $(".page-id-31549 ").is(":visible")) { // adjusting icon list quality accreds page movers
$(".col-md-6.padding-bottom-70.float_left:last-of-type()").removeClass("col-md-6").addClass("last-list");
$(".padding-bottom-70.float_left.last-list").css({'padding-bottom': '70px', 'margin-top': '-35px'});
$(".padding-bottom-70.float_left.last-list .list_content").css({'padding': '0 12px 0 166px'});
}
}
if ($('.ags_froesch').is(':visible')) { // ags froesch changes
$('div.center.column-image.block-1').replaceWith('<div class="center column-image  block-1"><img src="https://www.agsmovers.com/wp-content/uploads/2018/07/ags-froesch-individuals.jpg" class="attachment-full size-full" alt="" srcset="https://www.agsmovers.com/wp-content/uploads/2018/07/ags-froesch-individuals.jpg 580w, https://www.agsmovers.com/wp-content/uploads/2018/07/ags-froesch-individuals.jpg 300w" sizes="(max-width: 580px) 100vw, 580px" width="580" height="300"></div>');
$("#figures").insertAfter($("#network-home"));
}
    if ( $(".full_accreditations").is(":visible") && $(".row.right").is(":visible")){
      $(".useful-links").insertAfter($(".row").last());
    } else{
      $(".useful-links").insertAfter($(".more-content").last());
    }
    // Wysiwyg editor fix
    $('#icon-list h5 p, #intro h5 p, #error404 h5 p, #columns_plus h5 p, #flexi h5 p').replaceWith(function()
    {
      return '<span>' + $(this).html() + '</span>';
    });
});
    $('figcaption').replaceWith(function() //adds italics to post captions
    {
      return '<em><p><figcaption class="wp-caption-text">' + $(this).html() + '</figcaption></p></em>';
    });
    $('.no_branch').hide();// hide country with no branch
    if ($('.ags_records.de').is(':visible')) {
      $(".custom-logo").attr("src", "/wp-content/uploads/2018/04/pietsch.png").css({'height': '68px', 'width':'auto'});
    }
    var html = document.getElementsByTagName("html")[0].getAttribute("lang");
    var url = window.location.href;
    if( $('.de').is(':visible') ){
      $(document).ready(function(){$(".ags_movers .custom-logo").attr("src", "/wp-content/uploads/2018/04/froesch.png").css({'height': '68px', 'width':'220px'});});
    }else if ( url.indexOf('russia') !== -1 || url.indexOf('russie') !== -1){
      $(document).ready(function(){$(".ags_movers .custom-logo").attr("src", "/wp-content/uploads/2018/06/froesch_russia.png").css({'height': '68px', 'width':'220px'});});
    }

    else if (html == 'fr-FR' ) {
      $(document).ready(function(){$(".ags_records .custom-logo").attr("src", "/wp-content/uploads/sites/5/2018/01/ags_logo_fr.png");});
      $(document).ready(function(){$(".ags_movers .custom-logo").attr("src", "/wp-content/uploads/2018/05/ags_movers_fr.png");});
      if (url.indexOf('chine') !== -1){
        $(document).ready(function(){$(".ags_movers .custom-logo").attr("src", "/wp-content/uploads/2018/12/AGS_Logo_Removals_China-regions-en-1.png");});
        $(document).ready(function(){$(".ags_movers .custom_foot_logo").attr("src", "https://www.agsmovers.com/wp-content/uploads/2018/12/AGS_Logo_Removals_China-foot-en.png");});        
      }
      else if (url.indexOf('brexit') !== -1){
        $(document).ready(function(){$(".ags_movers .custom-logo").attr("src", "/wp-content/uploads/2019/04/relo_logo.png");});
        $(document).ready(function(){$(".ags_movers .custom_foot_logo").attr("src", "/wp-content/uploads/2019/04/footer-logo-relo.png");});
        $('#intro .col-md-6').removeClass('col-md-6').addClass('col-md-8');
      }
    }

    else if (html == 'zh-hans' ) {
      if (url.indexOf('agsfourwinds.cn') !== -1 ){
        $(document).ready(function(){$(".ags_movers .custom-logo").attr("src", "/wp-content/uploads/2018/12/AGS_Logo_Removals_China-regions-en-1.png");});
        $(document).ready(function(){$(".ags_movers .custom_foot_logo").attr("src", "https://www.agsmovers.com/wp-content/uploads/2018/12/AGS_Logo_Removals_China-foot-en.png");});        
      }    
    }    

    else if ( url.indexOf('china') !== -1){
      $(document).ready(function(){$(".ags_movers .custom-logo").attr("src", "/wp-content/uploads/2018/12/AGS_Logo_Removals_China-regions-en-1.png");});
      $(document).ready(function(){$(".ags_movers .custom_foot_logo").attr("src", "https://www.agsmovers.com/wp-content/uploads/2018/12/AGS_Logo_Removals_China-foot-en.png");});        
    }

    /* Detect Version of Firefox  */   
    if ($.browser.mozilla && $.browser.version <= "50.1.0" || $.browser.safari && $.browser.version <= "534.59.10" ){
      $(document).ready(function(){
        $('.rb-shape.col-md-6').hide();
        $("#flexi div.row div.container div.content h3").addClass('flx-title');
        $("h3.card-title").addClass('crd-title');
        $(".column-title").addClass('column_ttl');
      });
    }
    if ( $.browser.safari && $.browser.version <= "534.59.10" ){
      $(document).ready(function(){
        $('.layer2_text h4, .layer2-1_text h4,.layer3_text h4, .layer3-1_text h4').addClass('saf_534');
      });
    }
 // Query Mobile screens

    if ( $(window).width() < 900 ) {
      //$('.wpml-ls-item-de').hide();
      // mobile menu styling 
      $('.menu-item-41374, .menu-item-41375').addClass('mobile-quote-btn');
      if ($('.page-template-form-quote').is(':visible')) {
      $('.quote-button.mobile').addClass('form-page');
      }
      var menu_toggle = '<div class="menu-toggle"><div class="toggle-block menu-toggle-block toggle-block-1" id="toggle-block-1"></div></div>';

      $('.menu-main_menu-container').prepend(menu_toggle); // Movers
      $('.menu-main_menu-french-container').prepend(menu_toggle);
      $('.menu-main-menu-container').prepend(menu_toggle); // RM
      $('.menu-main-menu-fr-container').prepend(menu_toggle);
      $('li#menu-item-23978').replaceWith('<li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-23978"><span class="active-site"><a href="https://www.ags-archivage.com" style="float:left;">Archivage</a><a class="dropDwn fa fa-chevron-down"></a></span></li>');
      $('li#menu-item-24421').replaceWith('<li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-24421"><span class="active-site"><a href="https://www.ags-demenagement.com" style="float:left">Déménagement</a><a class="dropDwn fa fa-chevron-down"></a></span></li>');
      $('li#menu-item-17').replaceWith('<li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-17"><span class="active-site"><a href="https://www.ags-recordsmanagement.com" style="float:left;">Records Management</a><a class="dropDwn fa fa-chevron-down"></a></span></li>');
      $('li#menu-item-15566').replaceWith('<li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-15566"><span class="active-site"><a href="https://www.agsmovers.com/" style="float:left">Worldwide Movers</a><a class="dropDwn fa fa-chevron-down"></a></span></li>');
      $('li#menu-item-11').replaceWith('<li class="menu-item menu-item-type-custom menu-item-object-custom current-menu-item current_page_item menu-item-home menu-item-11"><span class="active-site"><a href="#" style="float:left">Relocation</a><a class="dropDwn fa fa-chevron-down"></a></span></li>');
      $('#topmenu').append('<a class="dropDwn fa fa-chevron-down"></a>');
      $('.nav-primary').addClass('original');
      $('#intro').removeClass('lifted');
      $(document).ready(function(){
      if ($('.ags_records').is(':visible')) {
         $("li#menu-item-23685 a:nth-child(2)").attr("href", "/#");
         $("li#menu-item-22537 a:nth-child(2)").attr("href", "/#");
         $('li#menu-item-25137 a').attr("href", "/filiales");
         $('li#menu-item-25134 a').attr("href", "/branches");
      }
      });
      if ($('.ags_movers').is(':visible')) {
      $('#menu-main_menu-french > li:nth-child(4)').replaceWith('<li id="menu-item-33928" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-33928"><a href="https://www.ags-demenagement.com/filiales">Notre réseau</a></li>');
      $('#menu-main_menu > li:nth-child(4)').replaceWith('<li id="menu-item-33926" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-33926"><a href="https://www.agsmovers.com/branches">Our Network</a></li>');
      } // links network page on mobile menu
      // to style all languages except fr
if ($('.fr').is(':visible')) {
$('#menu-top-menu-fr').removeClass('topnav');
}
      // movers mobile menu toggle
$(function() {
$('.menu-toggle').click(function(){ // opens & closes menu
$('.wp-custom-logo').toggleClass('open-menu');
});
$('.wrap.ags_container').click(function(){
$('.wp-custom-logo').removeClass('open-menu');
});
});
$('.menu-item-has-children').prepend('<div class="sub-drop-closed"></div>'); // target for sub-menu items
$('.menu-item-has-children').click(function(){
$('.sub-drop-closed').next().next('.sub-menu').toggleClass('display-block display-none');
$('.sub-drop-closed').toggleClass('sub-drop-open');
});
var choosing_ags = '.menu-item-33924';
var choisir_ags = '.menu-item-33927';
var services = '.menu-item-33925';
var services_fr = '.menu-item-33929';
var about_us = '.menu-item-22537';
var rm_services = '.menu-item-25273';
var sobre = '.menu-item-26092'; // pt
var rm_services_pt = '.menu-item-26111';
var a_propos = '.menu-item-23685';
var rm_services_fr = '.menu-item-25272';
var our_values = '.menu-item-24151';
var relo_services = '.menu-item-24152';

$(relo_services).click(function(){ // relo
$('body').addClass('stevewashere');
$(our_values).removeClass('sub-drop-open');
$('.menu-item-24151 .sub-menu').removeClass('display-block');
});
$(our_values).click(function(){ 
$(relo_services).removeClass('sub-drop-open');
$('.menu-item-24152 .sub-menu').removeClass('display-block');
});
$(services).click(function(){ // movers
$(choosing_ags).removeClass('sub-drop-open');
$('.menu-item-33924 .sub-menu').removeClass('display-block');
});
$(choosing_ags).click(function(){
$(services).removeClass('sub-drop-open');
$('.menu-item-33925 .sub-menu').removeClass('display-block');
});
$(services_fr).click(function(){
$(choisir_ags).removeClass('sub-drop-open');
$('.menu-item-33927 .sub-menu').removeClass('display-block');
});
$(choisir_ags).click(function(){
$(services_fr).removeClass('sub-drop-open');
$('.menu-item-33929 .sub-menu').removeClass('display-block');
});
$(about_us).click(function(){ // records
$(rm_services).removeClass('sub-drop-open');
$('.menu-item-25273 .sub-menu').removeClass('display-block');
});
$(sobre).click(function(){ // records
$(rm_services_pt).removeClass('sub-drop-open');
$('.menu-item-26092 .sub-menu').removeClass('display-block');
});
$(rm_services).click(function(){
$(about_us).removeClass('sub-drop-open');
$('.menu-item-22537 .sub-menu').removeClass('display-block');
});
$(a_propos).click(function(){
$(rm_services_fr).removeClass('sub-drop-open');
$('.menu-item-25272 .sub-menu').removeClass('display-block');
});
$(rm_services_fr).click(function(){
$(a_propos).removeClass('sub-drop-open');
$('.menu-item-23685 .sub-menu').removeClass('display-block');
});
      // fixes spacing on network section

      $("#network-home .container.padding-top-30").removeClass("container").removeClass("padding-top-30");

      // end of spacing fix

      $(window).scroll(function(){
          if ($(window).scrollTop() > 0) {
            $('.wp-custom-logo').delay(500).removeClass('open-menu');
          }
         if ($(window).scrollTop() > 128 ){
          $('#mega-menu-primary_navigation').css('visibility','hidden');
          $('.mega-menu-open').removeClass('mega-menu-open');
        }
        if ( $(window).scrollTop() == 0 || $(window).scrollTop() > 127 ) {
          $('#mega-menu-primary_navigation').css('visibility', 'visible');
        }
      });
      $('.wpml-ls-sub-menu a').css({'margin-right':'6px', 'background-color':'transparent'});
          $('.dropDwn').click(function(){
            $(this).toggleClass('fa-chevron-up fa-chevron-down');
            $('.wp-custom-logo').removeClass('open-menu');
            if ($(this).hasClass('fa-chevron-up')){
              $("#topbar").animate({height: "55px"});
              $(".topnav li:not(:first-child)").css({'display': 'block'});
              $("#menu-top-menu-fr li:not(:first-child)").css({'display': 'block'});
            } else {
              $("#topbar").animate({height: "28px"}, 300);
              $(".topnav li:not(:first-child)").css({'display': 'none'});
              $("#menu-top-menu-fr li:not(:first-child)").css({'display': 'none'});
            }
          });
    } // end mobile scripts
    // add default scripts here
    if ($('#portal').is(':visible')) { // client portal page
    $('#intro div.col-md-6').removeClass('col-md-6');
    }
      if ( localStorage.getItem('cookie_banner') !== 'notice' ) // Set Up Cookie Notice
      {
            $('.cookies').fadeIn();
            $('.site-info').addClass('margin-bottom-60');
      }
      $('.cookie_dismiss').click(function(){
          $('.cookies').fadeOut();
          localStorage.setItem('cookie_banner', 'notice'); // Setting the localStorage key = cookie_banner
          $('.site-info').removeClass('margin-bottom-60');
      });
  $(document).ready(function(){
  if ($('.rtl.he').is(':visible')) { // coz we got that jewish flow 02.10.18
    $('#intro a.ags_cta').text(' קבל הצעת מחיר');
  }
  $(function() {
    /* Movers also gets an interactive map 24.10.2018 {NB} */
  $('.africa-a').hover(function(){ // hover over tooltip
  $('.tooltipp.africa').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.africa').delay(500).fadeTo("fast", 0);
  });
  $('.americas-a').hover(function(){ // hover over tooltip
  $('.tooltipp.americas').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.americas').fadeTo("fast", 0);
  });
  $('.asia-a').hover(function(){ // hover over tooltip
  $('.tooltipp.asia').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.asia').fadeTo("fast", 0);
  });
  $('.europe-a').hover(function(){ // hover over tooltip
  $('.tooltipp.europe').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.europe').fadeTo("fast", 0);
  });
  $('.middle-east-a').hover(function(){ // hover over tooltip
  $('.tooltipp.middle-east').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.middle-east').fadeTo("fast", 0);
  });
  $('.australasia-a').hover(function(){ // hover over tooltip
  $('.tooltipp.australasia').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.australasia').fadeTo("fast", 0);
  });
  });
  if ($('.ags_relocation').is(':visible')) {
    $('#footer-services h3').wrap('<a href="/our-services"></a>');
    $('#footer-hubs h3').wrap('<a href="/our-hubs"></a>');
    $('.footer-post-col h3').wrap('<a href="/news"></a>');

  $(function() { // network map tooltips 19.10.2018 {NB}
  $('.hong-kong-a').hover(function(){ // hover over tooltip
  $('.tooltipp.hong-kong').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.hong-kong').delay(500).fadeTo("fast", 0);
  });
  $('.dubai-a').hover(function(){ // hover over tooltip
  $('.tooltipp.dubai').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.dubai').fadeTo("fast", 0);
  });
  $('.london-a').hover(function(){ // hover over tooltip
  $('.tooltipp.london').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.london').fadeTo("fast", 0);
  });
  $('.amsterdam-a').hover(function(){ // hover over tooltip
  $('.tooltipp.amsterdam').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.amsterdam').fadeTo("fast", 0);
  });
  $('.paris-a').hover(function(){ // hover over tooltip
  $('.tooltipp.paris').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.paris').fadeTo("fast", 0);
  });
  $('.cape-town-a').hover(function(){ // hover over tooltip
  $('.tooltipp.cape-town').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.cape-town').fadeTo("fast", 0);
  });
  $('.united-states-a').hover(function(){ // hover over tooltip
  $('.tooltipp.united-states').fadeTo("fast", 0.9);
  },function(){
  $('.tooltipp.united-states').fadeTo("fast", 0);
  });
  });
  }
  if ($('.fr').is(':visible')) { // translates load more button on news page
  $('span.elm-button-text').replaceWith('<span class="elm-button-text">Voir plus de news</span>');
  }
  if ($("#network").is(":visible")) { // fixes breadcrumb styling for network pages
  $("#breadcrumbs").addClass("network-crumbs");
  }
  if ($('#related-news').is(':visible')) {
    $(".item").addClass('col-md-4');
  }
  if (($(".page-id-33408").is(":visible")) || ($(".page-id-33417").is(":visible"))) { // cta on tenancy management
  $(".more-content p").css({'text-align': 'center'});
  }
  if ( $('#error404').is(':visible') ){ // removing animations on 404
  $('.numbers').css({'opacity': '1'});
  $('.numbers-label').css({'opacity': '1'});
  $('.solution-box').css({'display': 'block'});
  $('#figures .col-md-3').css({'opacity': '1'});
  }
  if ($('.error404.en.fr').is(':visible')) {
    $('.error404.fr').removeClass('en');
  }

  // styling on error404
  $('#error404 span:nth-child(2)').prepend('<br /><br />');
  if ($(".no-city-content").is(":visible")) { //fixes spacing issues on custom RM branches
            $("#intro p").addClass("branch-no-city");
            $("#intro p:nth-of-type(1)").text($("#intro p:nth-child(-n+2)").text());
            }
});
   $(window).scroll(function(){
    var side_img = $('.intro_img');
    var services_1 = $('.services-1');
    var services_2 = $('.services-2');
    var services_3 = $('.services-3');
    var services_4 = $('.services-4');
    var services_5 = $('.services-5');
    var services_6 = $('.services-6');
    var scrl = $(window).scrollTop();
    if ( $(window).width() < 900 ) {
    if (scrl > 0) {
    $('.wpml-ls-touch-device').css({'opacity': '0'}); // mobile language switcher (more than 2 languages)
    }
    if (scrl >= 100) {
    $('#menubar').addClass('low-index');
    $('.nav-primary').addClass('cloned');
    $('.nav-primary').removeClass('original');
    }
    else {
    $('.wpml-ls-touch-device').css({'opacity': '1'});
    $('#menubar').removeClass('low-index');
    $('.nav-primary').removeClass('cloned');
    $('.nav-primary').addClass('original');
    }
    }
     if (scrl >= 100) {
       // Intro Image Animation
       side_img.delay(500).queue(function(){side_img.addClass('image-fade-in')});
     }
     if ($('#error404').is(':visible') ) { // Services animation
          if (scrl >= 75) {
              services_1.delay(500).fadeIn();
              services_2.delay(700).fadeIn();
              services_3.delay(900).fadeIn();
              services_4.delay(1100).fadeIn();
              services_5.delay(1300).fadeIn();
              services_6.delay(1500).fadeIn();
          }
       }
     if ($('.ags_movers').is(':visible') ) { // Services animation
          if ($('.rtl').is(':visible')) { // Hebrew text 02.10.2018
            services_1.css({'display': 'block'});
            services_2.css({'display': 'block'});
            services_3.css({'display': 'block'});
            services_4.css({'display': 'block'});
            services_5.css({'display': 'block'});
            services_6.css({'display': 'block'});
          }
          if (scrl >= 650) {
              services_2.delay(500).fadeIn();
              services_1.delay(700).fadeIn();
              services_3.delay(900).fadeIn();
              services_4.delay(1100).fadeIn();
              services_5.delay(1300).fadeIn();
              services_6.delay(1500).fadeIn();
          }
       }
       else {
        if (scrl >= 450) {
              services_1.delay(500).fadeIn();
              services_2.delay(700).fadeIn();
              services_3.delay(900).fadeIn();
              services_4.delay(1100).fadeIn();
              services_5.delay(1300).fadeIn();
              services_6.delay(1500).fadeIn();
          }
       }
     });
   jQuery(document).ready(function(){ // card columns animation
    if ($('.ags_movers').is(':visible')) { // no animation for relo 17.10.2018 {NB}
      if ( jQuery('#card-columns').is(':visible') ){
        var aftr_cards = jQuery('#card-columns').next().next();
        var card_1 = jQuery('#card-columns .col-md-4 h3').first();
        var card_2 = jQuery('#card-columns .col-md-4').first().next().find('h3');
        var card_3 = jQuery('#card-columns .col-md-4').first().next().next().find('h3');
          var screen = jQuery(window);
          screen.scroll(function() {  
              // Start Cards Animation
              var cardT = card_1.offset().top,
                  cardH = card_1.outerHeight(),
                  cardwH = screen.height(),
                  cardS = screen.scrollTop();

                  if ( cardS > (cardT+cardH-cardwH) && (cardT > cardS) && (cardS+cardwH > cardT+cardH) ){
                   // Cards Animation
                    aftr_cards.queue(function() {
                      card_1.delay(800).queue(function(){card_1.addClass('card-animation')});
                      card_2.delay(1200).queue(function(){card_2.addClass('card-animation')});
                      card_3.delay(1600).queue(function(){card_3.addClass('card-animation')});
                    }); 
                  }
          });
        }
      }
  });
   $('#columns').find('.alignnone').removeClass('alignnone').addClass('aligncenter'); // makes sure icons align correctly
  $('#columns .col-md-3 p').replaceWith(function() {
      return '<h4>' + $(this).html() + '</h4>';
    }); // gives icon titles h4
    if ($('body').hasClass('home') || $('body').hasClass('page-id-33')){ // Slides only load on home page + hub page relo
      // Slider scripts go here 
      $(document).ready(function(){
        $(".slide-images li:nth-child(1) img").addClass("fx_0");
        //$(".relo_slide li:nth-child(1)").addClass("number_0");
        var timer;
        var timers;
          // var relo_sliders = document.getElementsByClassName('slider_text'); // Array to loop through
          //   for (var x = 0; x < relo_sliders.length; x++){ // Loop
          //     relo_sliders[x].classList.add('number_'+x); // Adding classNames
          //   }

          //$(".relo_slide li").eq(2).addClass("current");// Specific to relo only

        //   function reloslide(){ // 
        //     var current = $(".relo_slide li.current");
        //     var next = current.next().length ? current.next() : current.parent().children(':first');
        //     current.removeClass("current").animate({"opacity": "0"}, 800);
        //     next.addClass("current").animate({"opacity" :"1"}, 800);
        //     // repeat by calling the loop method again 
        //     timers = setTimeout(reloslide, 8000);
        //  }

        // if ($('.ags_relocation').is(':visible')) { 
        //   reloslide(); // start the loop when the page loads
        // }

         // we set the 'fx' class on the first image when the page loads
        // you can increase or decrease this value to get different effects
          // this calls the kenBurns function every 4 seconds
          window.setInterval(kenBurns, 5000);

          //the third variable is to keep track of where we are in the loop
          //if it is set to 1 (instead of 0) it is because the first image is styled when the page loads
          var images          = $(".slide-images img");
          var numberOfImages  = images.length;
          
          var i= 1;


          function kenBurns() {
          if(i==numberOfImages){ i = 0;}
          images[i].className = "fx" + '_' + i;
          
          if(i===0){
            images[numberOfImages-2].className = " ";
           
          }
          if(i===1){
            images[numberOfImages-1].className = " ";
            
          }
          if(i>1){
            images[i-2].className = " ";
           
          }
          i++;
          }

       $(".slide_img li").eq(2).addClass("current");
       function textloop(){
          var current = $(".slide_img li.current");
          var next = current.next().length ? current.next() : current.parent().children(':first');
          current.removeClass("current").animate({"opacity": "0"}, 800);
          next.addClass("current").animate({"opacity" :"1"}, 800);
          // repeat by calling the loop method again 
          timers = setTimeout(textloop, 5000);
       }
         // call method when page loads
         textloop();

     $("#ags_slider span a.next").eq(2).addClass("active");
        function bullets(){
            var bullet = $("#ags_slider span a.active");
            var next = bullet.next().length ? bullet.next() : bullet.parent().children(':first');
            next.addClass("active");
            bullet.removeClass("active");
            timer = setTimeout(bullets, 5000);
        }
        // call method when page loads
        bullets();

        var first_bullet = $(".next.1");
        var second_bullet = $(".next.2");
        var third_bullet = $(".next.3");
        var fourth_bullet = $(".next.4");
        var fifth_bullet = $(".next.5");
        var sixth_bullet = $(".next.6");
        var slide_1 = $("li.slider_text").eq(0);
        var slide_2 = $("li.slider_text").eq(1);
        var slide_3 = $("li.slider_text").eq(2);
        var slide_4 = $("li.slider_text").eq(3);
        var slide_5 = $("li.slider_text").eq(4);
        var slide_6 = $("li.slider_text").eq(5);
        
  
            first_bullet.click(function(){
            first_bullet.addClass("active");
            slide_1.addClass("current").animate({"left": "7em", "opacity" :"1"}, 100);
            slide_2.removeClass("current").animate({"opacity": "0"}, 300);
            slide_3.removeClass("current").animate({"opacity": "0"}, 300);
            slide_4.removeClass("current").animate({"opacity": "0"}, 300);
            slide_5.removeClass("current").animate({"opacity": "0"}, 300);
            slide_6.removeClass("current").animate({"opacity": "0"}, 300);
          
            clearTimeout(timers);
            clearTimeout(timer);
            second_bullet.removeClass("active");
            third_bullet.removeClass("active");
            fourth_bullet.removeClass("active");
            fifth_bullet.removeClass("active");
            sixth_bullet.removeClass("active");

            });

            second_bullet.click(function(){
            second_bullet.addClass("active");
            slide_2.addClass("current").animate({"left": "7em", "opacity" :"1"}, 100);
            slide_1.removeClass("current").animate({"opacity": "0"}, 300);
            slide_3.removeClass("current").animate({"opacity": "0"}, 300);
            slide_4.removeClass("current").animate({"opacity": "0"}, 300);
            slide_5.removeClass("current").animate({"opacity": "0"}, 300);
            slide_6.removeClass("current").animate({"opacity": "0"}, 300);
            
            clearTimeout(timers);
            clearTimeout(timer);
            first_bullet.removeClass("active");
            third_bullet.removeClass("active");
            fourth_bullet.removeClass("active");
            fifth_bullet.removeClass("active");
            sixth_bullet.removeClass("active");
            });

            third_bullet.click(function(){
            third_bullet.addClass("active");          
            slide_3.addClass("current").animate({"left": "7em", "opacity" :"1"}, 100);
            slide_2.removeClass("current").animate({"opacity": "0"}, 300);
            slide_1.removeClass("current").animate({"opacity": "0"}, 300);
            slide_4.removeClass("current").animate({"opacity": "0"}, 300);
            slide_5.removeClass("current").animate({"opacity": "0"}, 300);
            slide_6.removeClass("current").animate({"opacity": "0"}, 300);
            
            clearTimeout(timers);
            clearTimeout(timer);
            second_bullet.removeClass("active");
            first_bullet.removeClass("active");
            fourth_bullet.removeClass("active");
            fifth_bullet.removeClass("active");
            sixth_bullet.removeClass("active");
            });

            fourth_bullet.click(function(){
            fourth_bullet.addClass("active");          
            slide_4.addClass("current").animate({"left": "7em", "opacity" :"1"}, 100);
            slide_3.removeClass("current").animate({"opacity": "0"}, 300);
            slide_2.removeClass("current").animate({"opacity": "0"}, 300);
            slide_1.removeClass("current").animate({"opacity": "0"}, 300);
            slide_5.removeClass("current").animate({"opacity": "0"}, 300);
            slide_6.removeClass("current").animate({"opacity": "0"}, 300);

            clearTimeout(timers);
            clearTimeout(timer);
            third_bullet.removeClass("active");
            second_bullet.removeClass("active");
            first_bullet.removeClass("active");
            fifth_bullet.removeClass("active");
            sixth_bullet.removeClass("active");
            });

            fifth_bullet.click(function(){
            fifth_bullet.addClass("active");          
            slide_5.addClass("current").animate({"left": "7em", "opacity" :"1"}, 100);
            slide_4.removeClass("current").animate({"opacity": "0"}, 300);
            slide_3.removeClass("current").animate({"opacity": "0"}, 300);
            slide_2.removeClass("current").animate({"opacity": "0"}, 300);
            slide_1.removeClass("current").animate({"opacity": "0"}, 300);
            slide_6.removeClass("current").animate({"opacity": "0"}, 300);
  
            clearTimeout(timers);
            clearTimeout(timer);
            fourth_bullet.removeClass("active");
            third_bullet.removeClass("active");
            second_bullet.removeClass("active");
            first_bullet.removeClass("active");
            sixth_bullet.removeClass("active");
            });

            sixth_bullet.click(function(){
            sixth_bullet.addClass("active");
            slide_6.addClass("current").animate({"left": "7em", "opacity" :"1"}, 100);
            slide_5.removeClass("current").animate({"opacity": "0"}, 300);
            slide_4.removeClass("current").animate({"opacity": "0"}, 300);
            slide_3.removeClass("current").animate({"opacity": "0"}, 300);
            slide_2.removeClass("current").animate({"opacity": "0"}, 300);
            slide_1.removeClass("current").animate({"opacity": "0"}, 300);
 
            clearTimeout(timers);
            clearTimeout(timer);
            fifth_bullet.removeClass("active");
            fourth_bullet.removeClass("active");
            third_bullet.removeClass("active");
            second_bullet.removeClass("active");
            first_bullet.removeClass("active");
            });
        
  });
  }
  $(document).ready(function() {
  if ($('.ags_records.de').is(':visible')) { // network, country, branch pages not in DE on RM 19.10.2018 {NB}
    $( '#branch_dropdown_menu a, #network-home a, .slider_text a:nth-child(1), .menu-our-network_de-container a' ).each( function( index, element ){var url = $( element ).prop( 'href' );if ( url.indexOf( '?' ) == -1 ) {url += '?de=not_available';}$( element ).prop( 'href', url );});
  }

  // Preselect corporate enquirires on general enquiries page 21.06.2018
  $( '.corporate-enquiries a' ).each( function( index, element ){var url = $( element ).prop( 'href' );if ( url.indexOf( '?' ) == -1 ) {url += '?corporation';}$( element ).prop( 'href', url );});
  $( 'a.corporate-enquiries' ).each( function( index, element ){var url = $( element ).prop( 'href' );if ( url.indexOf( '?' ) == -1 ) {url += '?corporation';}$( element ).prop( 'href', url );});
  var url = location.search;
  if (url == '?de=not_available') { // shows the message on /branches page
    $('.de-not-available').fadeTo('slow', 1);
    $('.de-not-available button.cross').click(function(){
      $('.de-not-available').fadeTo('slow', 0);
    });
  }

  if (url == '?corporation') {
  var pleaseChoose = 'select[name=PleaseChoose]';
  var new_value = 'Corporate Services';
  var new_value_fr = 'Services aux entreprises';
  if ($('.fr').is(':visible')) {
  $(pleaseChoose).val(new_value_fr);
  }
  else {
    $(pleaseChoose).val(new_value);
  }
  }
  });

  $(document).ready(function() {
  // Preselect containers from groupage destination pages
  var url = location.search;
  var destination = $(location).attr('pathname');
  destination.indexOf(2);
  destination = destination.split("/")[2];
  $( '.container_cta a' ).each( function( index, element ){var url = $( element ).prop( 'href' );if ( url.indexOf( '?' ) == -1 ) {url += '?destination=' + destination;}$( element ).prop( 'href', url );});
 
 // if there are no containers, the link on the pano goes to containers page
  if ($('.groupage-cta a:nth-child(1)').attr('href') == '/groupage') {
    $( '.groupage-cta a:nth-child(1)' ).each( function( index, element ){var url = $( element ).prop( 'href' );if ( url.indexOf( '?' ) == -1 ) {url += '?destination=' + destination;}$( element ).prop( 'href', url );});
  }
  function getQueryVariable(variable) { // for the containers page
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
  }
  var dest = getQueryVariable("destination");
  if (url == '?destination=' + dest) {
    var clean_dest = dest.replace(/\b\w/g, l => l.toUpperCase()); // adds capital
    var country = 'select[id=countries]';
    var new_val = $('#countries option:contains("' + clean_dest + '")').val();
    $(country).val(new_val);
  }

    // Tabs function
    function responsiveTabs() {
      // Tabs functionality
        $('.responsive-tabs').each(function() {
          // Hide all tab panels except for the first
            $('.responsive-tabs-panel').not(':first').hide();

          // Add active statuses to first tab and show display
            $('li', this).removeClass('active');
            $('li:first-child', this).addClass('active');
            $('.responsive-tabs-panel:first-child').show();

          // Tab clicked
            $('li', this).click(function(e) {
              // Prevent the anchor's default click action
                e.preventDefault();

              // Corresponding tabs panel
                var panel = $('a', this).attr('href');

              // Remove active statuses to other tabs
                $(this).siblings().removeClass('active');

              // Add active status to this tab
                $(this).addClass('active');

              // Hide other tab panels
                $(panel).siblings().hide();

              // Showing the clicked tabs' panel
                $(panel).fadeIn(400);
            });

          // Responsive
            if ($(window).width() < 768)
              $('.responsive-tabs-panel').show();
        });

      // Panel link functionality
        $('.responsive-tabs-content .responsive-tabs-panel .responsive-tabs-panel-link').on('click', function(e) {
          // Corresponding tabs panel
            var panel = $(this).attr('href');

          // Remove active statuses to other tabs
            $(this).parents('.responsive-tabs-content').siblings('.responsive-tabs').find('a[href=' + panel + ']').parent().siblings().removeClass('active');

          // Add active status to this tab
            $(this).parents('.responsive-tabs-content').siblings('.responsive-tabs').find('a[href=' + panel + ']').parent().addClass('active');

          // Hide other tab panels
            //$(panel).siblings().hide();

          // Showing the clicked tabs' panel
            $(panel).fadeIn(400);

          // Prevent the anchor's default click action
            e.preventDefault();
        });
    }

  $(document).ready(function() {
    responsiveTabs();

    $('.responsive-tabs li a').each(function() {
      var tabID = $(this).attr('href');
      var tabTitle = $(this).html();

      $(tabID + ' .responsive-tab-title').prepend('<p><strong>' + tabTitle + '</strong></p>');
    });
  });

  $(window).resize(function() {
    responsiveTabs();
  });   

  $('.dark_bg').find('.column-block').css({'border' : 'none', 'border-radius' : '0', 'background' : 'none'});
  $('.dark_bg').find('h4').css({'color' : '#fff', 'text-transform' : 'none'});
  });

},
finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};





// WEBPACK FOOTER //
// ./scripts/routes/common.js